import request from '@/utils/service'

export function list(data) {
  return request({
    url: '/marketing/list',
    method: 'get',
    params: data
  })
}

export function update(data) {
  return request({ url: '/marketing/update', data })
}

export function setCouponsRule(data) {
  return request({ url: '/coupon/giveoutRule/updateRule', data })
}
